import { registerEnumType } from 'type-graphql'

export enum CouponDiscountTypeEnum {
  Percentage = 'Percentage',
  FixedAmount = 'FixedAmount',
}

registerEnumType(CouponDiscountTypeEnum, {
  name: 'CouponDiscountTypeEnum',
  description: 'How a Coupon reduces the charged price — Percentage discounts by a %, FixedAmount discounts by a flat amount in the purchase currency.',
})
